import React, { useEffect, useMemo, useRef, useState } from "react";
import "./ComboInput.css";

// ComboInput is a free-text input with a suggestions dropdown positioned directly under the
// field (unlike the native <datalist>, which some browsers misplace). You can type any value;
// the list just offers existing options to reuse. Used for the checklist category field.
export default function ComboInput({ value, onChange, options, placeholder }) {
    const [open, setOpen] = useState(false);
    const wrapRef = useRef(null);

    const matches = useMemo(() => {
        const q = (value || "").trim().toLowerCase();
        return options.filter(o => o.toLowerCase() !== q && (!q || o.toLowerCase().includes(q)));
    }, [options, value]);

    useEffect(() => {
        function onDoc(e) {
            if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
        }
        document.addEventListener("mousedown", onDoc);
        return () => document.removeEventListener("mousedown", onDoc);
    }, []);

    return (
        <div className="combo-wrap" ref={wrapRef}>
            <input
                value={value}
                placeholder={placeholder}
                onChange={e => { onChange(e.target.value); setOpen(true); }}
                onFocus={() => setOpen(true)}
            />
            {open && matches.length > 0 && (
                <div className="combo-dropdown">
                    {matches.map(o => (
                        <button type="button" key={o} className="combo-option"
                            onClick={() => { onChange(o); setOpen(false); }}>
                            {o}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
